// DepartmentDropdown.js

import React, { useEffect, useState } from "react";
import { Form, Select } from 'antd';
import DepartmentsApi from '../Apis/DepartmentsApi';
import {
    ReloadOutlined,
    SyncOutlined,
} from "@ant-design/icons";
import { Link } from "react-router-dom";
import StorageSuggestionApi from "../Apis/StorageSuggestionApi";

const StorageSuggestionModel = ({ onStorageSuggestionResponse }) => {

    const [Storages2, setStorages2] = React.useState([]);
    const [loading, setLoading] = useState(false);
    const [TotalPageNew, setTotalPageNew] = useState(null);
    const [page, setPage] = useState(0);

    const [IsReloadStorageClicked, setIsReloadStorageClicked] =
        useState(false);

    const handleReloadStorageClick = async () => {
        setIsReloadStorageClicked(true);
        try {
            let totalPages = 1;
            let currentPage = 0;
            let allStorages = [];

            do {
                const response = await StorageSuggestionApi?.ListStorage(currentPage,10);
                totalPages = response?.totalPages || [];
                allStorages = [...allStorages, ...(response?.payloadDto || [])];
                currentPage++;
                
            } while(currentPage < totalPages);

            setTotalPageNew(totalPages);
            setStorages2(allStorages);
            setPage(currentPage);
        } catch (error) {
            console.error("Error fetching Storages",error);
        } finally {
            setIsReloadStorageClicked(false);
        }
        setTimeout(() => {
            setIsReloadStorageClicked(false);
        }, 1000);
    };

    const fetchStorages = async () => {
        try {
            setLoading(true);

                let totalPages = 1;
                let currentPage = 0;
                let allStorages = [];
            
            do {
                const response = await StorageSuggestionApi?.ListStorage(currentPage,10);
                allStorages = [...allStorages, ...(response?.payloadDto || [])];
                totalPages = response?.totalPages || 0;
                currentPage++;

            } while (currentPage < totalPages);
            
            setTotalPageNew(totalPages);
            setPage(currentPage);
            setStorages2(allStorages);

        } catch (error) {
            console.error('Error fetching departments:', error);
        } finally {
            setLoading(false);
        }
    };

    const handleChangeProduct = (value) => {
        StorageSuggestionApi.Singlestorage(value).then((response) => {
            onStorageSuggestionResponse(response.payload);

        })
            .catch((err) => {
                console.log(err);
            });
    };

    useEffect(() => {
        fetchStorages();
    }, []);

    return (
        <><div className="row product-row d-flex ">
            <Form.Item
                name="StorageSuggessionID"
                label="Storage Suggestions :"
                className="text-lable col-10"
                rules={[
                    {
                        required: true,
                        message: "Please Select Storage Suggestions.",
                    },
                ]}
            >
                <Select
                    className="control-Select mb-1"
                    placeholder="Select Storage"
                    onChange={(value) => handleChangeProduct(value)}
                >
                    {Storages2.map((option, index) => (
                        <Select.Option key={index} value={option.id}>
                            {option.name}
                        </Select.Option>
                    ))}
                    {loading && (
                        <Select.Option disabled key="loading" value="loading">
                            Loading...
                        </Select.Option>
                    )}
                </Select>
            </Form.Item>
            <div className=" col-2">
                {IsReloadStorageClicked ? (
                    <div className="refresh-btn">
                        <SyncOutlined spin className="px-2" />
                    </div>
                ) : (
                    <div
                        className="refresh-btn"
                        onClick={handleReloadStorageClick}
                        style={{ cursor: "pointer" }}
                    >
                        <ReloadOutlined className="px-2" />
                    </div>
                )}
            </div>
        </div>
            <div className="row pb-2 ">
                <div className="col-4"></div>
                <div className="col-6">
                    <Link to={"/masters/storage-suggestions/add-storage-suggestions"} target="_blank">
                        <u>Create New Storage Suggestions</u>
                    </Link>
                </div>
            </div>
        </>

    );
};

export default StorageSuggestionModel;
